import React from 'react';
import { Page } from '../../../../../shared/Components/Page';
import {InformacionSubidaContainer} from './Screen';

export const InformacionSubidaView = () =>{

    return (
        <Page title={'Gestion DNs - Acceso a Información Subida'} scrollBody>{<InformacionSubidaContainer/>}</Page>
    )
}